export const getOrderSearchText = (order) => [
  order?.order_number,
  order?.payment_method,
  order?.cashier_name,
  order?.notes,
  ...(order?.items || []).flatMap(item => [
    item.menu_item_name,
    item.notes,
    ...(item.modifier_selections || []).flatMap(selection => [
      selection.modifier_group_name,
      selection.modifier_option_name,
      selection.raw_material_name,
    ]),
  ]),
].filter(Boolean).join(' ').toLowerCase();
